import { FormControl, Autocomplete, TextField } from "@mui/material";
import { TipoPedido, TipoPedidoTitulo } from "../../enum/TipoPedido";

interface AlterarTipoPedidoSelectProps {
    tipo: "simples" | "retirada" | "delivery" | "mesa" | TipoPedido;
    alterarTipo: (tipo: TipoPedido) => void;
}

const tiposPedido = [TipoPedido.delivery, TipoPedido.retirada, TipoPedido.mesa, TipoPedido.simples];

export const AlterarTipoPedidoSelect = ({ alterarTipo, tipo }: AlterarTipoPedidoSelectProps) => {
    return (
        <FormControl fullWidth sx={{ mt: '1rem' }}>
            <Autocomplete
                value={(tipo as TipoPedido) || null}
                onChange={(event, newValue) => {
                    if (newValue) {
                        alterarTipo(newValue);
                    }
                }}
                options={tiposPedido}
                getOptionLabel={(option) => TipoPedidoTitulo[option] || option}
                sx={{
                    '& .MuiAutocomplete-popper': {
                        '& .MuiPaper-root': {
                            borderRadius: '8px',
                        },
                    },
                    '& .MuiAutocomplete-listbox': {
                        '& .MuiAutocomplete-option': {
                            display: 'flex',
                            alignItems: 'center',
                        },
                    },
                }}
                renderInput={(params) => (
                    <TextField
                        {...params}
                        variant="filled"
                        sx={{
                            '& .MuiFilledInput-root': {
                                backgroundColor: 'white',
                                borderRadius: '12px',
                                boxShadow: 1,
                                minHeight: '56px',
                                paddingTop: '0px !important',
                                paddingBottom: '0px !important',
                                '&:hover': {
                                    boxShadow: 2,
                                },
                                '&.Mui-focused': {
                                    boxShadow: 3,
                                },
                                '&::before': {
                                    display: 'none',
                                },
                                '&::after': {
                                    display: 'none',
                                },
                            },
                            '& .MuiFilledInput-underline': {
                                '&::before': {
                                    display: 'none',
                                },
                                '&::after': {
                                    display: 'none',
                                },
                            },
                            '& .MuiInputBase-root': {
                                display: 'flex',
                                alignItems: 'center',
                            },
                            '& .MuiInputBase-input': {
                                textAlign: 'left',
                            },
                            '& .MuiFilledInput-input': {
                                padding: '18px 12px',
                                paddingTop: '18px',
                                paddingBottom: '18px',
                                lineHeight: '1.5',
                                display: 'flex',
                                alignItems: 'center',
                            },
                            '& .MuiAutocomplete-endAdornment': {
                                position: 'absolute',
                                right: '12px',
                                top: '50%',
                                transform: 'translateY(-50%)',
                                display: 'flex',
                                alignItems: 'center',
                            },
                        }}
                    />
                )}
            />
        </FormControl>
    );
};
